module.exports = __webpack_public_path__ + "static/media/instant_extra_logo.af883ca4.png";